import { Theme } from "@mui/material";

export const accordionTheme = Object.freeze({
  container: (theme: Theme, options?: { mobileBgColor?: string }) => ({
    // ":root": {
    //   borderRadius: "24px",
    // },
    ":before": {
      display: "none",
      background: "transparent",
    },
    padding: "28px 40px",
    background: "#2D2D2D",

    [theme.breakpoints.down("laptopXs")]: {
      padding: "18px 32px",
    },
    // [theme.breakpoints.down("tabletXs")]: {
    //   padding: "12px 24px",
    // },
    [theme.breakpoints.down("tabletXs")]: {
      boxShadow: "none",
      padding: "12px 24px",
      background: options?.mobileBgColor ?? "transparent",
    },
    [theme.breakpoints.down("mobileXl")]: {
      padding: "0px 16px",
      boxShadow: "none",
      background: options?.mobileBgColor ?? "transparent",
      // ":root": {
      //   borderRadius: "12px",
      // },
    },

    [theme.breakpoints.down("mobileXs")]: {
      padding: "16px",
      borderRadius: "32px",
      // ":root": {
      //   borderRadius: "12px",
      // },
    },
  }),

  subtitle: (theme: Theme) => ({
    fontWeight: 400,

    [theme.breakpoints.up("mobileXl")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.down("mobileXl")]: {
      fontSize: "12px",
    },
  }),

  infoText: (theme: Theme) => ({
    color: "#939393",
    marginRight: "24px",
    fontWeight: 400,
    fontSize: "clamp(10px, 1.05vw, 20px)",

    [theme.breakpoints.down("laptopXs")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.down("tabletXs")]: {
      display: "none",
    },
  }),

  expandIcon: (theme: Theme) => ({
    width: "32px",
    height: "32px",

    [theme.breakpoints.down("mobileXs")]: {
      width: "24px",
      height: "24.5px",
    },
  }),
});

export const actionBtnSize = (theme: Theme) => ({
  roundedDefault: {
    fontWeight: 500,
    borderRadius: "64px",

    [theme.breakpoints.up("laptopXs")]: {
      height: "64px",
      fontSize: "18px",
    },
    [theme.breakpoints.down("laptopXs")]: {
      height: "48px",
      fontSize: "14px",
    },
    [theme.breakpoints.down("tabletXl")]: {
      height: "48px",
      fontSize: "14px",
    },
    [theme.breakpoints.down("tabletXs")]: {
      height: "48px",
      fontSize: "14px",
    },
    [theme.breakpoints.down("mobileXl")]: {
      height: "48px",
      fontSize: "14px",
    },
    [theme.breakpoints.down("mobileXs")]: {
      height: "40px",
      fontSize: "14px",
    },
  },
  default: {
    borderRadius: "8px",
    fontWeight: 500,

    [theme.breakpoints.up("laptopXs")]: {
      height: "60px",
      fontSize: "18px",
    },
    [theme.breakpoints.down("laptopXs")]: {
      height: "60px",
      fontSize: "18px",
    },
    [theme.breakpoints.down("tabletXl")]: {
      height: "60px",
      fontSize: "18px",
    },
    [theme.breakpoints.down("tabletXs")]: {
      height: "60px",
      fontSize: "18px",
    },
    [theme.breakpoints.down("mobileXl")]: {
      height: "60px",
      fontSize: "18px",
    },
    [theme.breakpoints.down("mobileXs")]: {
      height: "60px",
      fontSize: "18px",
    },
  },
});
